// Setter CRM depth (spec §08.1 CRM side, §08.2, §08.7, §08.8). Schemas in api-crm-depth.ts.
import { LeadCrmSyncSchema } from './api-crm-depth.js';
import { IdParam, route, W } from './route-def.js';

export const crmDepthRoutes = {
  getLeadCrmSync: route({
    method: 'GET', path: '/workspaces/:workspaceId/leads/:interestId/crm', summary: 'Negocio en el CRM, estado de sincronización y siguiente acción de una oportunidad', tag: 'leads',
    minRole: 'advisor', module: null, params: W({ interestId: IdParam }), response: LeadCrmSyncSchema,
  }),
} as const;
